import { Alert, Box, CircularProgress, Grid, Typography } from '@mui/material'
import type { FC } from 'react'
import React from 'react'

export type Props = {
  loading?: boolean
  errorMessage?: string
  total?: number
}

const height = 300

const TotalBox: FC<Props> = ({ errorMessage, loading, total }) =>
  errorMessage ? (
    <Box height={height}>
      <Alert severity="error">
        <Typography variant="body2">{errorMessage}</Typography>
      </Alert>
    </Box>
  ) : loading ? (
    <Grid container sx={{ height, alignItems: 'center', justifyContent: 'center' }}>
      <span data-testid="total-loading">
        <CircularProgress />
      </span>
    </Grid>
  ) : (
    <Box height={height} display="flex" justifyContent="center" alignItems="center">
      <Typography component="p" variant="h1" gutterBottom>
        {total}
      </Typography>
    </Box>
  )

export default TotalBox
